import { useRef, useCallback } from 'react';

export const useSequentialAPI = () => {
  const sequenceRef = useRef(null);

  const executeSequence = useCallback(async (seoData, dispatch, actions) => {
    // Cancel any existing sequence
    if (sequenceRef.current) {
      sequenceRef.current.cancelled = true;
    }

    const sequence = { cancelled: false };
    sequenceRef.current = sequence;

    try {
      // Build SEO attributes for all APIs
      const seoAttributes = {};
      seoData?.forEach((item) => {
        if (item.attributeName && item.attributeValue) {
          const attrName = item.attributeName;
          switch (attrName) {
            case 'Product Type':
              seoAttributes.producttype = item.attributeValue;
              break;
            case 'Material':
              seoAttributes.material = item.attributeValue;
              break;
            case 'Category':
              seoAttributes.category = item.attributeValue;
              break;
            default:
              seoAttributes[attrName.toLowerCase().replace(/\s+/g, '')] = item.attributeValue;
          }
        }
      });

      // Ensure defaults
      if (!seoAttributes.material) seoAttributes.material = 'Silver';
      if (!seoAttributes.category) seoAttributes.category = 'Jewellery';

      if (sequence.cancelled) return;

      console.log('Starting sequential API calls with SEO data:', seoAttributes);

      // Step 1: Price Range API
      console.log('Calling getPriceRangeMinMax');
      await dispatch(actions.getPriceRangeMinMax(seoAttributes));
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for completion
      
      if (sequence.cancelled) return;

      // Step 2: Filter List API  
      console.log('Calling product_list_filter');
      await dispatch(actions.product_list_filter(seoData));
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for completion
      
      if (sequence.cancelled) return;

      // Step 3: Product List API
      console.log('Calling product_list_item');
      const productPayload = { ...seoAttributes };
      await dispatch(actions.product_list_item(productPayload, 0));

    } catch (error) {
      if (!sequence.cancelled) {
        console.error('Sequential API error:', error);
      }
    } finally {
      if (sequenceRef.current === sequence) {
        sequenceRef.current = null;
      }
    }
  }, []);

  const cancelSequence = useCallback(() => {
    if (sequenceRef.current) {
      sequenceRef.current.cancelled = true;
      sequenceRef.current = null;
    }
  }, []);

  return { executeSequence, cancelSequence };
};